module.exports = __webpack_public_path__ + "img/dataviz.561e5275.svg";